<template>
  <div class="CommandRightCard">
    <h5><span>{{itemObj.title}}</span></h5>
    <div class="rowContent"
      v-for="(item,index) in itemObj.dataArr"
      :key="index">
      <p :style="{color:itemObj.title=='EIOT'?colorList[index]:'#EBEEF3'}">{{item.name}}</p>

      <p><animate-number from="1"
          ref="myNumAnimate"
          :key="item.value"
          :to="item.value">
        </animate-number>{{item.unit?' '+item.unit:''}}</p>
      <p>{{item.scale}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      colorList: ["#3EF9FC", "#EBEEF3", "#E54553"],
    };
  },
  methods: {
    startAnimate() {
      this.$nextTick(() => {
        this.$refs.myNumAnimate.map((v) => {
          v.start();
        });
      });
    },
  },
  mounted() {
    this.$bus.$on("handleNumberChange", (data) => {
      this.startAnimate();
    });
  },
  beforeDestroy() {
    this.$bus.$off("handleNumberChange");
  },
};
</script>

<style lang="scss" scoped>
.CommandRightCard {
  width: 90%;
  height: 23%;
  margin: 0 auto;
  background: url("~@/assets/images/msgt/rowBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  @include setFlexColumn;
  justify-content: space-around;
  h5 {
    color: #3ef9fc;
    text-align: center;
    margin-top: 10px;
    font-size: 15px;
    span {
      display: inline-block;
      position: relative;
    }
    span:before,
    span::after {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      top: 50%;
      margin-top: -2px;
      border-top: 4px solid #3ef9fc;
      border-left: 4px solid #3ef9fc;
      border-bottom: 4px solid #3ef9fc;
      border-right: 4px solid #3ef9fc;
      transform: rotate(45deg);
    }
    span:before {
      left: -15px;
    }
    span::after {
      right: -15px;
    }
  }
  .rowContent {
    @include setFlexAround;
    p {
      width: 33%;
      text-align: center;
      color: #ebeef3;
    }
  }
  .rowContent:last-child {
    margin-bottom: 15px;
  }
}
</style>